<template>
  <div class="shopOrder">
    <div class="shopList" v-for="(shop) of shopsData" :key="shop.shopId">
      <!-- <div class="shopName">店铺：{{shop.shopName}}</div> -->
      <div class="orderList">
        <div class="orderItem" v-for="(order) of shop.skus" :key="order.skuId">
          <div class="commodity itemBox">
            <img :src="order.image" :alt="order.productName">
            <span>{{order.productName}}</span>
          </div>
          <div class="attributes itemBox">
            <!-- <span>{{order.sku}}</span> -->
            <span>{{order.values.join('/')}}</span>
          </div>
          <div class="unitPrice itemBox">￥{{order.price}}</div>
          <div class="numberBox itemBox">{{order.number}}</div>
<!--          <div class="discountBox itemBox">-->
<!--            <el-select v-model="order.discountName" placeholder="请选择">-->
<!--              <el-option-->
<!--                v-for="yhItem in order.discountList"-->
<!--                :key="yhItem.value"-->
<!--                :label="yhItem.label"-->
<!--                :value="yhItem.label">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <div class="activityBox itemBox">{{type==0?'无':type==1?'拼团':type==2?'秒杀':type==3?'折扣':''}}</div>
          <div class="totalBox itemBox">￥{{order.total}}</div>
        </div>
      </div>
<!--      <div class="remarksBox">-->
<!--        <div class="remarksInfo">-->
<!--          <el-input-->
<!--            type="textarea"-->
<!--            :rows="2"-->
<!--            resize="none"-->
<!--            placeholder="如有其他要求，请备注。"-->
<!--            v-model="shop.remarksInfo">-->
<!--          </el-input>-->
<!--        </div>-->
<!--      </div>-->
      <div class="orderTotalBox">
        <div class="shippingBox">运费：￥{{shop.distribution.distributionPrice}}</div>
        <div class="orderTotalBox">订单合计：<b>￥{{shop.total + shop.distribution.distributionPrice}}</b></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopOrder',
  props: {
    shopsData: Array,
    type: Number
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.shopOrder {
  .shopName {
    padding-left: 20px;
    margin-bottom: 30px;
    color: #333333;
    font-size: 16px;
  }
  .orderList {
    width: 100%;
    .orderItem {
      width: 100%;
      display: flex;
      border: 1px solid #E5E5E5;
      border-bottom: none;
      padding: 30px 0;
      box-sizing: border-box;
      .itemBox {
        color: #333333;
        font-size: 16px;
        text-align: center;
        line-height: 80px;
      }
      .commodity {
        width: 40%;
        display: flex;
        img {
          width: 80px;
          height: 80px;
          margin-left: 15px;
        }
        span {
          width: 320px;
          margin-left: 30px;
          text-align: left;
        }
      }
      .attributes {
        width: 20%;
        text-align: left;
        color: #999999;
        font-size: 16px;
        span {
          display: block;
          margin-bottom: 5px;
        }
      }
      .unitPrice {
        width: 15%;
        text-align: center;
      }
      .numberBox {
        width: 15%;
        text-align: center;
      }
      .activityBox {
        width: 10%;
        text-align: center;
        font-size: 16px;
      }
      .discountBox {
        width: 20%;
        display: flex;
        justify-content: center;
        color: #666666;
        >>> .el-select {
          width: 200px;
          .el-input__inner {
            height: 34px;
            line-height: 34px;
          }
        }
      }
      .totalBox {
        width: 10%;
        text-align: center;
        color: $mainColor;
        font-weight: bold;
      }
    }
    .orderItem:last-child {
      border-bottom: 1px solid #E5E5E5;
    }
  }
  .remarksBox {
    display: flex;
    background: #F7F7F7;
    padding: 25px 35px;
    .remarksInfo {
      width: 100%;
      >>> .el-textarea__inner {
        width: 100%;
        height: 84px;
      }
    }
    .selectBox {
      margin-left: 70px;
      label {
        color: #666666;
        font-size: 16px;
        font-weight: normal;
      }
    }
    .shopTotal {
      color: $mainColor;
      flex: 1;
      text-align: right;
    }
  }
  .shopList {
    margin-bottom: 50px;
    .orderTotalBox {
      margin-top: 20px;
      text-align: right;
      .shippingBox {
        color: #333333;
        font-size: 14px;
      }
      .orderTotalBox {
        font-size: 14px;
        color: #333333;
        b {
          color: $mainColor;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/shopOrder.vue